import { Box } from '@mui/system';
import Stack from '@mui/material/Stack';
import moment from 'moment';
import TextValue from '../../../../examDoctor/component/therapy/TherapySessionDetail/PrintTherapySessionDialog/PrintDialogContent/TextValue';
import { BE_DATE_TIME_FORMAT, FE_DATE_FORMAT, PATIENT_ADDRESS_TYPE, PAYMENT_PLAN } from '../../../../common/constants';
import { Encounter } from 'modules/schema';

interface Props {
  encounter: Encounter;
  compact: boolean;
}

const PatientInfo = ({ encounter, compact }: Props) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Box flex={1.5}>
        <TextValue label="patientId" value={encounter?.patient?.formatCode || ''} labelWidth="110px" />
        <TextValue label="name" value={encounter?.patient?.name || ''} labelWidth="110px" />
        <TextValue label="telephone" value={encounter?.patient?.mobilePhone || ''} labelWidth="110px" />
        {!compact && (
          <TextValue
            label="category"
            value={PAYMENT_PLAN[encounter?.paymentPlan!].label}
            localizationValue
            labelWidth="110px"
          />
        )}
      </Box>
      <Box flex={1}>
        <TextValue
          labelWidth="90px"
          label="address"
          value={
            encounter?.patient?.patientAddressList?.find((ele) => ele?.type === PATIENT_ADDRESS_TYPE.home)?.address ||
            ''
          }
        />
        <TextValue
          label="birthdayShort"
          value={moment(encounter?.patient?.dob, BE_DATE_TIME_FORMAT).format(FE_DATE_FORMAT)}
          labelWidth="90px"
        />
        <TextValue
          label="gender"
          value={encounter?.patient?.gender?.toLowerCase() || ''}
          localizationValue
          labelWidth="90px"
        />
      </Box>
    </Stack>
  );
};

export default PatientInfo;
